import { IController } from 'angular';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';

export class SorterColInputDetailsCtrl implements IController {
  static $inject = ['ImUser', 'SorterColInputTypes'];

  // bindings
  private disabled;
  private inputType;
  private items;
  private label;
  private ngModel;
  private placeholder;
  private onChange;

  // local
  private isInput;
  private isCheckbox;
  private isDropdown;
  private isAutocomplete;
  private isUserPicker;

  constructor(private ImUser: ImUser, private SorterColInputTypes) {}

  $onInit() {
    if (!this.inputType) {
      throw new Error('inputType is required by nvSorterColInputDetails component');
    }
    this.isInput = this.isCheckbox = this.isDropdown = this.isAutocomplete = this.isUserPicker = false;

    switch (this.inputType) {
      case this.SorterColInputTypes.TEXT:
        this.isInput = true;
        break;
      case this.SorterColInputTypes.CHECKBOX:
        this.isCheckbox = true;
        break;
      case this.SorterColInputTypes.DROPDOWN:
        this.isDropdown = true;
        break;
      case this.SorterColInputTypes.AUTOCOMPLETE:
        this.isAutocomplete = true;
        break;
      case this.SorterColInputTypes.USER_PICKER:
        this.isUserPicker = true;
        break;
      default:
        throw new Error('Invalid datatype value');
    }
  }

  getFullUserName(userMini) {
    return this.ImUser.getFullNameWithEmailFromMini(userMini);
  }
}

angular
  .module('nv.components.sorter-col-input-details')
  .controller('SorterColInputDetailsCtrl', SorterColInputDetailsCtrl);
